// DokumentyZaznamu.jsx — REK_REGISTER_V1 (21. 10. 2026; dohoda s Dokumentmi Kronika matrix 2782 b. 5, GO 2804)
// Záložka Dokumenty na karte ĽUBOVOĽNÉHO záznamu = TEN ISTÝ register documents prefiltrovaný cez document_links
// (typ reklamacia / project / customer …), nie kópia (0.J). Zovšeobecnenie DokumentyZamestnanca.jsx; ten ostáva
// a prepne sa sem v dávke Matrix-mozgu dokumenty_zaznam_v1. Nový dokument vzniká v Dokumentoch (/api/doc-archive/draft,
// číslo KAMIR/ROK/NNN dáva server) a hneď sa naviaže na záznam (zaznamApi + '/list-zapis'); upravuje sa v DokumentEditor.
import React, { useEffect, useState, useCallback, useRef } from 'react'
import DokumentEditor from './DokumentEditor.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { COLORS, TYPO, SPACE, RADIUS, SK } from '../theme.js'
import { useToast } from './Toast.jsx'

const tlac = { padding: '4px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, background: COLORS.bg, cursor: 'pointer', fontFamily: 'inherit', fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.text, whiteSpace: 'nowrap' }
const tlacP = { ...tlac, background: COLORS.nav, borderColor: COLORS.nav, color: '#fff' }
const orez = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }   // REK_REGISTER_V1C

const bunka = { padding: '5px 8px', borderBottom: `1px solid ${COLORS.lineSoft}`, fontSize: TYPO.sizes.sm, verticalAlign: 'middle', textAlign: 'left' }
const fmtD = (x) => { try { return SK.date(String(x || '').slice(0, 10)) } catch (_) { return String(x || '').slice(0, 10) } }

// stav dokumentu slovom (61.10: stav je slovo, farbu nesie len to, čo si žiada pozornosť)
function stav(d) {
  if (d.smer === 'dosle' || d.kind === 'incoming') return ['prijatý', COLORS.muted]
  if (d.status === 'na_podpis') return ['čaká na podpis', COLORS.warn || '#854F0B']
  if (d.status === 'podpisany' || d.status === 'signed' || d.kep_signed_at) return ['podpísané', COLORS.add]
  if (d.sent_at || d.status === 'sent') return ['odoslané ' + (d.sent_at ? SK.datumCas(d.sent_at) : ''), COLORS.add]
  if (d.kind === 'uploaded' || d.is_editable === 0) return ['archív', COLORS.muted]
  return ['draft — neodoslané', COLORS.remove]
}

// JEDNA cesta k dokumentu zo záznamu (0.J): draft v Dokumentoch (číslo zo servera, väzby zákazka + partner) → väzba na záznam → id pre editor.
// t = { doc_type, vec, title, body, tpl_key }; preset = { projectId, customerId, adresat:{firma,ulica,psc_mesto,do_ruk,email}, vasaZnacka, vec }
export async function zalozDokumentZaznamu(preset, zaznamApi, t) {
  const p = preset || {}; const a = p.adresat || {}; t = t || {}
  const telo = {
    doc_type: t.doc_type || 'Stanovisko', vec: t.vec || p.vec || '', title: t.title || '', body: t.body || '', doc_mode: 'vec',
    project_id: p.projectId || '', vasa_znacka: p.vasaZnacka || '',
    adr_firma: a.firma || '', adr_ulica: a.ulica || '', adr_psc_mesto: a.psc_mesto || '', adr_do_ruk: a.do_ruk || '', adr_email: a.email || '',
    vazby: [p.projectId ? { typ: 'project', ref_id: p.projectId } : null, p.customerId ? { typ: 'customer', ref_id: p.customerId } : null].filter(Boolean),
  }
  if (t.tpl_key) telo.tpl_key = t.tpl_key
  const r = await fetchAuth('/api/doc-archive/draft', { method: 'POST', body: JSON.stringify(telo) })
  const j = await r.json().catch(() => ({}))
  if (!r.ok || !j.id) throw new Error(j.error || 'Dokument sa nepodarilo založiť')
  if (zaznamApi) {
    const z = await fetchAuth(zaznamApi + '/list-zapis', { method: 'POST', body: JSON.stringify({ archive_id: j.id, naviaz: true }) })
    if (!z.ok) { const e = await z.json().catch(() => ({})); throw new Error(e.error || 'Väzba na záznam zlyhala') }
  }
  return j.id
}

// REK_REGISTER_V1C: dalsie = [{ typ, id, nadpis }] — dokumenty iných záznamov (napr. zákazky), ktoré k tomuto záznamu ešte nie sú naviazané;
// „Priradiť“ ich naviaže cez zaznamApi/list-zapis (0.J — ten istý dokument, len ďalšia väzba). Mirko 21. 10.: „list 009 zo 6. 10. karta nevie“.
export default function DokumentyZaznamu({ typ, id, preset = {}, zaznamApi, tlacidla = [], onZmena, poznamka, dalsie = [] }) {
  const toast = useToast()
  const [docs, setDocs] = useState(null)
  const [editor, setEditor] = useState(null)   // { docId }
  const [busy, setBusy] = useState(false)
  const fileRef = useRef(null)
  const load = useCallback(() => {
    if (!typ || !id) return
    fetchAuth('/api/doc-archive?vazba_typ=' + encodeURIComponent(typ) + '&vazba_id=' + encodeURIComponent(id))
      .then(r => r.ok ? r.json() : { documents: [] }).then(d => setDocs(d.documents || [])).catch(() => setDocs([]))
  }, [typ, id])
  useEffect(() => { load() }, [load])
  const [dalsieDocs, setDalsieDocs] = useState([])
  const kluc = (dalsie || []).map(d => d.typ + ':' + d.id).join('|')
  useEffect(() => {
    let zivy = true
    if (!kluc) { setDalsieDocs([]); return }
    Promise.all((dalsie || []).filter(d => d && d.typ && d.id).map(d => fetchAuth('/api/doc-archive?vazba_typ=' + encodeURIComponent(d.typ) + '&vazba_id=' + encodeURIComponent(d.id)).then(r => r.ok ? r.json() : { documents: [] }).then(j => (j.documents || []).map(x => ({ ...x, _z: d }))).catch(() => [])))
      .then(zoz => { if (zivy) setDalsieDocs([].concat(...zoz)) })
    return () => { zivy = false }
  }, [kluc, docs])   // zámerne: dalsie sa mení len cez kluc
  const priradit = async (x) => {
    if (!zaznamApi || busy) return
    setBusy(true)
    try {
      const z = await fetchAuth(zaznamApi + '/list-zapis', { method: 'POST', body: JSON.stringify({ archive_id: x.id, naviaz: true }) })
      if (!z.ok) { const e = await z.json().catch(() => ({})); throw new Error(e.error || 'Priradenie zlyhalo') }
      toast.success((x.nasa_znacka || x.title || 'Dokument') + ' priradený k tomuto záznamu.'); load(); onZmena && onZmena()
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  const pdf = (x) => x.pdf_path ? '/uploads/' + x.pdf_path : (x.filename ? '/uploads/' + x.filename : '')
  const vazby = (x) => (x.vazby || []).filter(v => v.typ === typ).length

  // nový dokument: draft v Dokumentoch (server dá číslo) → väzba na záznam → editor; nič sa nepíše dvakrát (preset z karty)
  const novy = async (t) => {
    if (busy) return
    setBusy(true)
    try {
      const docId = await zalozDokumentZaznamu(preset, zaznamApi, t)
      toast.success('Dokument založený a naviazaný — číslo dal server.')
      load(); onZmena && onZmena()
      setEditor({ docId })
    } catch (e) { toast.error(e.message) } finally { setBusy(false) }
  }
  // prijatý list objednávateľa (PDF z e-mailu) → dokument smer došlé + väzba (2782 b. 2)
  const nahraj = async (files) => {
    if (!files || !files.length || busy) return
    setBusy(true)
    try {
      for (const f of files) {
        const fd = new FormData(); fd.append('file', f)
        fd.append('smer', 'dosle'); fd.append('doc_type', preset.prijatyDruh || 'Oznámenie o vadách'); fd.append('title', f.name); fd.append('project_id', preset.projectId || '')
        const r = await fetchAuth('/api/doc-archive/upload', { method: 'POST', body: fd })
        const j = await r.json().catch(() => ({}))
        if (!r.ok || !j.id) throw new Error(j.error || 'Nahranie zlyhalo')
        if (zaznamApi) await fetchAuth(zaznamApi + '/list-zapis', { method: 'POST', body: JSON.stringify({ archive_id: j.id, naviaz: true }) })
      }
      toast.success('Prijatý list uložený do Dokumentov a naviazaný.'); load(); onZmena && onZmena()
    } catch (e) { toast.error(e.message) } finally { setBusy(false); if (fileRef.current) fileRef.current.value = '' }
  }
  const odpoj = async (x) => {
    if (!zaznamApi) return
    if (!window.confirm('Odpojiť dokument ' + (x.nasa_znacka || x.title || x.id) + ' od tohto záznamu? Dokument v registri ostáva.')) return
    try {
      const r = await fetchAuth(zaznamApi + '/listy/' + encodeURIComponent(x.id), { method: 'DELETE' })
      if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.error || 'Odpojenie zlyhalo') }
      toast.success('Odpojené.'); load(); onZmena && onZmena()
    } catch (e) { toast.error(e.message) }
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
        {tlacidla.map((t, i) => <button key={i} type="button" style={i === 0 ? tlacP : tlac} disabled={busy} onClick={() => novy(t)}>{t.label}</button>)}
        {zaznamApi && (
          <label style={{ ...tlac, cursor: busy ? 'default' : 'pointer' }}>
            {busy ? 'Pracujem…' : 'Nahrať prijatý list'}
            <input ref={fileRef} type="file" accept=".pdf,image/*,.eml,.msg" multiple disabled={busy} onChange={e => nahraj(e.target.files)} style={{ display: 'none' }} />
          </label>)}
      </div>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, margin: '6px 0 8px' }}>
        {poznamka || 'Ten istý register ako modul Dokumenty — tu dokumenty naviazané na tento záznam. Odoslanie, história a odpoveď druhej strany sú v Dokumentoch.'}
      </div>
      {!docs ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Načítavam…</div> : docs.length === 0 ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Zatiaľ žiadny dokument.</div> : (
        <table style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed' }}>{/* REK_REGISTER_V1C — pevné šírky, nič nepretečie doprava (Mirko 21. 10., bod 11) */}
          <colgroup>{[17, 10, 25, 12, 12, 9, 15].map((w, i) => <col key={i} style={{ width: w + '%' }} />)}</colgroup>
          <thead><tr>{['Číslo', 'Druh', 'Predmet', 'Dátum', 'Stav', 'Väzby', ''].map(h => <th key={h} style={{ ...bunka, color: COLORS.muted, fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.xs, textTransform: 'uppercase', letterSpacing: '.04em', background: COLORS.bgSoft }}>{h}</th>)}</tr></thead>
          <tbody>{docs.map(x => { const st = stav(x); const n = vazby(x); return (
            <tr key={x.id} style={{ height: 34 }}>
              <td style={{ ...bunka, ...orez, fontFamily: TYPO.mono }} title={x.nasa_znacka || ''}>{x.nasa_znacka || '—'}</td>
              <td style={{ ...bunka, ...orez }} title={x.doc_type || ''}>{x.doc_type || '—'}</td>
              <td style={{ ...bunka, ...orez }} title={x.title || x.vec || x.filename}>{x.title || x.vec || x.big_title || x.filename || '—'}</td>
              <td style={{ ...bunka, ...orez, fontFamily: TYPO.mono }}>{fmtD(x.datum || x.created_at)}</td>
              <td style={{ ...bunka, ...orez, color: st[1], fontWeight: TYPO.weights.semibold }} title={st[0]}>{st[0]}</td>
              <td style={{ ...bunka, ...orez, color: COLORS.muted, fontSize: TYPO.sizes.xs }}>{n > 1 ? n + ' záznamov' : ''}{(x.vazby || []).some(v => v.typ === 'project') ? (n > 1 ? ' · ' : '') + 'zákazka' : ''}{(x.vazby || []).some(v => v.typ === 'customer') ? ' · partner' : ''}</td>
              <td style={{ ...bunka, textAlign: 'right', whiteSpace: 'normal' }}>
                {pdf(x) && <button type="button" style={{ ...tlac, margin: '0 0 2px 4px' }} onClick={() => window.open(pdf(x), '_blank')}>PDF</button>}
                {x.kind !== 'podpis_ep' && x.is_editable !== 0 && !x.sent_at && x.status !== 'sent' && !x.kep_signed_at && <button type="button" style={{ ...tlac, margin: '0 0 2px 4px' }} onClick={() => setEditor({ docId: x.id })}>Upraviť / odoslať</button>}
                {x.is_editable !== 0 && !x.sent_at && x.status !== 'sent' && <button type="button" style={{ ...tlac, margin: '0 0 2px 4px' }} onClick={() => odpoj(x)} title="Odpojiť od záznamu (dokument ostáva v Dokumentoch)">Odpojiť</button>}
              </td>
            </tr>) })}</tbody>
        </table>
      )}
      {(() => {
        const uz = new Set((docs || []).map(x => x.origin_id || x.id))
        const kand = dalsieDocs.filter(x => !uz.has(x.origin_id || x.id) && !(x.vazby || []).some(v => v.typ === typ && String(v.ref_id) === String(id)))
        const videne = new Set(); const zoz = kand.filter(x => { const k = x.origin_id || x.id; if (videne.has(k)) return false; videne.add(k); return true })
        if (!zoz.length) return null
        return (
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 4 }}>
              Ďalšie dokumenty {(dalsie || []).map(d => d.nadpis).filter(Boolean).join(' · ') || 'súvisiacich záznamov'} — k tomuto záznamu nie sú naviazané <span style={{ fontFamily: TYPO.mono, fontWeight: TYPO.weights.medium }}>{zoz.length}</span>
            </div>
            <table style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed' }}>
              <colgroup>{[17, 10, 30, 13, 13, 17].map((w, i) => <col key={i} style={{ width: w + '%' }} />)}</colgroup>
              <tbody>{zoz.slice(0, 40).map(x => { const st = stav(x); return (
                <tr key={x.id} style={{ height: 32 }}>
                  <td style={{ ...bunka, ...orez, fontFamily: TYPO.mono }} title={x.nasa_znacka || ''}>{x.nasa_znacka || '—'}</td>
                  <td style={{ ...bunka, ...orez }} title={x.doc_type || ''}>{x.doc_type || '—'}</td>
                  <td style={{ ...bunka, ...orez }} title={x.title || x.vec}>{x.title || x.vec || x.big_title || x.filename || '—'}</td>
                  <td style={{ ...bunka, ...orez, fontFamily: TYPO.mono }}>{fmtD(x.datum || x.created_at)}</td>
                  <td style={{ ...bunka, ...orez, color: st[1], fontWeight: TYPO.weights.semibold }} title={st[0]}>{st[0]}</td>
                  <td style={{ ...bunka, textAlign: 'right', whiteSpace: 'normal' }}>
                    {pdf(x) && <button type="button" style={{ ...tlac, margin: '0 0 2px 4px' }} onClick={() => window.open(pdf(x), '_blank')}>PDF</button>}
                    {zaznamApi && <button type="button" style={{ ...tlacP, margin: '0 0 2px 4px' }} disabled={busy} onClick={() => priradit(x)} title="Naviazať tento dokument aj na tento záznam (dokument ostáva jeden)">Priradiť</button>}
                  </td>
                </tr>) })}</tbody>
            </table>
          </div>)
      })()}
      {editor && <DokumentEditor open docId={editor.docId} context={{ projectId: preset.projectId || '' }} onClose={() => { setEditor(null); load(); onZmena && onZmena() }} onSaved={() => { load(); onZmena && onZmena() }} />}
    </div>
  )
}
